var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhatsapp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 33.6655C25.2152 33.6655 31.875 27.0058 31.875 18.7905C31.875 10.5753 25.2152 3.91553 17 3.91553C8.78476 3.91553 2.125 10.5753 2.125 18.7905C2.125 21.4583 2.82731 23.9621 4.05713 26.1271L2.125 33.6655L9.89704 31.8633C12.0077 33.0126 14.4276 33.6655 17 33.6655ZM17 31.3771C23.9514 31.3771 29.5865 25.7419 29.5865 18.7905C29.5865 11.8392 23.9514 6.20399 17 6.20399C10.0486 6.20399 4.41346 11.8392 4.41346 18.7905C4.41346 21.4745 5.25353 23.9622 6.68508 26.0051L5.55769 30.2328L9.85993 29.1573C11.8887 30.5572 14.3486 31.3771 17 31.3771Z",
    fill: "#BFC8D0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.75 17.728C29.75 24.7697 24.0416 30.478 17 30.478C14.3142 30.478 11.8223 29.6476 9.7672 28.2294L5.40909 29.3189L6.55112 25.0363C5.10098 22.9669 4.25 20.4468 4.25 17.728C4.25 10.6864 9.95837 4.97803 17 4.97803C24.0416 4.97803 29.75 10.6864 29.75 17.728Z",
    fill: "url(#paint0_linear_14570_93693)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 32.603C25.2152 32.603 31.875 25.9433 31.875 17.728C31.875 9.51279 25.2152 2.85303 17 2.85303C8.78476 2.85303 2.125 9.51279 2.125 17.728C2.125 20.3958 2.82731 22.8996 4.05713 25.0646L2.125 32.603L9.89704 30.8008C12.0077 31.9501 14.4276 32.603 17 32.603ZM17 30.3146C23.9514 30.3146 29.5865 24.6794 29.5865 17.728C29.5865 10.7767 23.9514 5.14149 17 5.14149C10.0486 5.14149 4.41346 10.7767 4.41346 17.728C4.41346 20.412 5.25353 22.8997 6.68508 24.9426L5.55769 29.1703L9.85993 28.0948C11.8887 29.4947 14.3486 30.3146 17 30.3146Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2813 10.8217C12.9276 10.1114 12.3851 10.1743 11.837 10.1743C10.8574 10.1743 9.33008 11.3476 9.33008 13.5312C9.33008 15.3208 10.1187 17.2798 12.7759 20.2102C15.3404 23.0384 18.71 24.5014 21.5073 24.4516C24.3047 24.4018 24.8802 21.9945 24.8802 21.1816C24.8802 20.8213 24.6566 20.6415 24.5026 20.5926C23.5493 20.1351 21.7912 19.2827 21.3911 19.1225C20.9911 18.9624 20.7822 19.179 20.6524 19.2969C20.2896 19.6426 19.5705 20.6614 19.3242 20.8906C19.078 21.1198 18.7109 21.0038 18.5582 20.9172C17.996 20.6916 16.4719 20.0136 15.2569 18.8359C13.7544 17.3794 13.6662 16.8783 13.3831 16.4322C13.1567 16.0753 13.3229 15.8564 13.4058 15.7607C13.7295 15.3872 14.1765 14.8105 14.377 14.5239C14.5774 14.2373 14.4183 13.8022 14.3228 13.5312C13.9121 12.3657 13.5642 11.39 13.2813 10.8217Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_14570_93693",
    x1: 28.1562,
    y1: 8.16553,
    x2: 4.25,
    y2: 30.478,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5BD066"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#27B43E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp);
export default __webpack_public_path__ + "static/media/whatsapp.a6a786657762d66951fc070a43895437.svg";
export { ForwardRef as ReactComponent };